import {
  createUnifiedTheme,
  createBaseThemeOptions,
  palettes,
  genPageTheme,
  shapes,
} from '@backstage/theme';

// Fondative brand gradient: magenta → violet
const MAGENTA = '#E5007A';
const VIOLET = '#7B2FBE';

const fondativePageTheme = genPageTheme({
  colors: [VIOLET, MAGENTA],
  shape: shapes.wave,
});

export const fondativeTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: MAGENTA,
        light: '#FF3399',
        dark: '#B3005E',
        contrastText: '#ffffff',
      },
      secondary: {
        main: VIOLET,
        light: '#9B4FD4',
        dark: '#5A1F9B',
        contrastText: '#ffffff',
      },
      error: {
        main: '#D32F2F',
      },
      warning: {
        main: '#F57C00',
      },
      success: {
        main: '#2E7D32',
      },
      info: {
        main: VIOLET,
      },
      background: {
        default: '#F5F5F7',
        paper: '#FFFFFF',
      },
      banner: {
        info: VIOLET,
        error: '#D32F2F',
        text: '#ffffff',
        link: '#ffffff',
      },
      navigation: {
        background: '#1A0A2E',
        indicator: MAGENTA,
        color: '#C8B8DC',
        selectedColor: '#ffffff',
        navItem: {
          hoverBackground: 'rgba(229, 0, 122, 0.15)',
        },
        submenu: {
          background: '#110720',
        },
      },
    },
  }),
  fontFamily: '"Montserrat", "Inter", "Roboto", sans-serif',
  defaultPageTheme: 'home',
  pageTheme: {
    home: fondativePageTheme,
    documentation: genPageTheme({ colors: [MAGENTA, VIOLET], shape: shapes.wave2 }),
    tool: genPageTheme({ colors: [VIOLET, MAGENTA], shape: shapes.round }),
    service: genPageTheme({ colors: [MAGENTA, VIOLET], shape: shapes.wave }),
    website: genPageTheme({ colors: [VIOLET, MAGENTA], shape: shapes.wave }),
    library: genPageTheme({ colors: [MAGENTA, VIOLET], shape: shapes.wave2 }),
    other: fondativePageTheme,
    app: fondativePageTheme,
    apis: fondativePageTheme,
  },
});
